(function () {
	'use strict';

	const nav = document.querySelector('.header__nav');
	const header = document.querySelector('.header');
	const hamburger = document.querySelector('.header__hamburger');
	const headerButtons = document.querySelectorAll('.header .owl-carousel .owl-prev, .header .owl-carousel .owl-next');

	if (!nav || !header || !hamburger) return;

	const ACTIVE = '__js_isActive';
	const ITEM_ACTIVE = '__active';

	function openCloseMenu(toggle) {
		[hamburger, nav, header].forEach(el => el.classList[toggle ? 'toggle' : 'remove'](ACTIVE));
	}

	function setActiveItem(item) {
		// zdejmij aktywność z poprzednich elementów
		nav.querySelectorAll(`.item.${ITEM_ACTIVE}`).forEach(el => el.classList.remove(ITEM_ACTIVE));
		nav.querySelectorAll(`a[data-slug].${ITEM_ACTIVE}`).forEach(el => el.classList.remove(ITEM_ACTIVE));

		// ustaw aktywność na klikniętym elemencie i jego linku (jeśli jest)
		item.classList.add(ITEM_ACTIVE);
		const link = item.querySelector('a[data-slug]');
		if (link) link.classList.add(ITEM_ACTIVE);
	}

	hamburger.addEventListener('click', function () {
		openCloseMenu(true);

		const firstActiveLink = nav.querySelector('.item.__js_isActive a, .item.__active a');
		if (firstActiveLink) firstActiveLink.focus();

		// staty
		(window.dataLayer = window.dataLayer || []).push({
			event: 'site_interaction',
			eventCategory: 'header_hamburger',
			eventAction: ('ontouchstart' in window) ? 'tap' : 'click'
		});
	});

	header.addEventListener('mouseleave', function () {
		openCloseMenu(false);
	});


	// delegacja kliknięć w nawigacji
	nav.addEventListener('click', function (e) {
		const item = e.target.closest('.item');
		if (!item || !nav.contains(item)) return;

		setActiveItem(item);
		openCloseMenu(true); // zamknij/otwórz zgodnie z dotychczasową logiką
	});

	let hideTimer;

	headerButtons.forEach(btn => {
		btn.addEventListener('click', () => {

			// tylko mobile
			if (!window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;

			// zdejmij napis z OBU
			headerButtons.forEach(b => b.classList.remove('show-text'));

			// pokaż tylko na klikniętym
			btn.classList.add('show-text');

			// reset timera
			clearTimeout(hideTimer);
			hideTimer = setTimeout(() => {
			headerButtons.forEach(b => b.classList.remove('show-text'));
			}, 1200);
		});
	});
})();
